<template>
	<div class="page-one report-page">
		<div id="reportPage" class="report-page-content" @click="clickReportPage">
			<div class="report-left-content">
				<audio-button :className="'report-audio-button'"></audio-button>
				<!-- 1. 顶部部分 -->
				<report-top-bar :type="'report'"></report-top-bar>
			</div>
			<div class="report-right-content">
				<div class="report-right-content-content">
					<!-- <div class="report-top-btn-about" @click="clickAbout"></div>
					<div class="report-top-btn-trend" @click="clickTrend"></div> -->
					<!-- 2. 牛运走势 -->
					<report-fortune-trend></report-fortune-trend>
					<!-- 3. 财运能量牛先知 -->
					<report-wealth-energy></report-wealth-energy>

					<!-- 4. 二维码 -->
					<div class="report-code-img-outbox">
						<div class="report-code-img-box">
							<img :src="codeImg" class="report-code-img" alt="">
							<div class="report-code-text">扫码关注公众号</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		
		<!-- 5. 支付完成提示弹框 -->
		<van-popup v-bind:value="reportShowSuccess">
			<report-pay-success></report-pay-success>
		</van-popup>
		<!-- 6. 测算完成提示弹框 -->
		<van-popup v-bind:value="reportShowBefore" position="bottom" @click-overlay="clickBeforeOverlay">
			<report-before></report-before>
		</van-popup>
		<van-popup v-bind:value="reportShowPayCode">
			<report-pay-code></report-pay-code>
		</van-popup>
		<!-- 7. 两个按钮 -->
		<div class="report-main-button report-main-button-one" @click="clickAgain"><span>再测<br/>一次</span></div>
		<span class="report-main-button report-main-button-two" @click="clickReport"><span>测算<br/>记录</span></span>
		<!-- 8. 关于桃花涧 -->
		<van-popup v-bind:value="reportShowAbout" position="bottom" v-bind:close-on-click-overlay="false">
			<about-popup></about-popup>
		</van-popup>
		<!-- 9. 分享 -->
		<van-popup v-bind:value="reportShowShare" position="top" @click-overlay="clickShareOverlay">
			<div class="report-share"></div>
		</van-popup>
	</div>
</template>

<script>
	import { DOM } from '../modules/utils'
	import { WEIXIN } from '../modules/weixin'
	import AudioButton from '../components/common/AudioButton.vue'
	import ReportTopBar from '../components/report/ReportTopBar.vue'
	import ReportBefore from '../components/report/ReportBefore.vue'
	import ReportPayCode from '../components/report/ReportPayCode.vue'
	import ReportFortuneTrend from '../components/report/ReportFortuneTrend.vue'
	import ReportWealthEnergy from '../components/report/ReportWealthEnergy.vue'
	import ReportPaySuccess from '../components/report/ReportPaySuccess.vue'
	import AboutPopup from '../components/AboutPopup.vue'
	export default {
		components: { AudioButton, ReportTopBar, ReportBefore, ReportPayCode, ReportFortuneTrend, ReportWealthEnergy, ReportPaySuccess, AboutPopup },
		computed: {
			userInfo() {
				return this.$store.state.userData.info;
			},
			isNewCreated() {
				return this.$store.state.user.isNewCreated;
			},
			gotUserPageData() {
				return this.$store.state.user.gotUserPageData;
			},
			reportShowSuccess() {
				return this.$store.state.user.reportShowSuccess;
			},
			reportShowBefore() {
				return this.$store.state.user.reportShowBefore;
			},
			reportShowPayCode() {
				return this.$store.state.pay.reportShowPayCode;
			},
			reportShowAbout() {
				return this.$store.state.user.reportShowAbout;
			},
			reportShowShare() {
				return this.$store.state.user.reportShowShare;
			}
		},
		data() {
			return {
				codeImg: 'http://m1.2048.net/duoniu/images_rabbit/report/code.jpeg',
			}
		},
		mounted() {
			// AUDIO.playAudio('report');
			setTimeout(function() {
				if(!this.gotUserPageData) {
					this.$router.replace('/home');
				}
				this.$bus.emit('playReportAudio');
			}.bind(this), 20);
			setTimeout(function() {
				if(this.isNewCreated) {
					this.$store.state.user.reportShowBefore = true;
				}
				// DOM.setStopTouchById('reportPage');
			}.bind(this), 1500);
		},
		methods: {
			clickAgain() {
				this.$router.replace('/index');
			},
			clickReport() {
				this.$router.replace('/record');
			},
			clickReportPage() {
				this.$store.state.user.reportShowTip = false;
			},
			clickAbout() {
            	this.$store.state.user.reportShowAbout = true;
			},
			clickTrend() {
				var scrollY = window.screen.height*0.9 < 600 ? window.screen.height*0.9 : 600;
				setTimeout(() => {
					window.scrollTo(0, scrollY);
				}, 20);
			},
			clickBeforeOverlay() {
				this.$store.state.user.isNewCreated = false;
            	this.$store.state.user.reportShowBefore = false;
			},
			clickShareOverlay() {
            	this.$store.state.user.reportShowShare = false;
			}
		}
	}
</script>

<style>
</style>
